import ReactDOM from 'react-dom';
import WizardPage from './components/wizard';

const loadWizard = () => {
    const onboardWizardDiv = document.getElementById('jkit-onboard-wizard');

    if (onboardWizardDiv) {
         ReactDOM.render(
            <WizardPage/>,
            onboardWizardDiv
        );
    }
};

window.addEventListener('load', () => {
    loadWizard();
});
